export default __webpack_public_path__ + "img/settings-estop.2899cba9.png";